import { render, staticRenderFns } from "./SearchHelpCard.vue?vue&type=template&id=10bbbd91"
import script from "./SearchHelpCard.vue?vue&type=script&lang=js"
export * from "./SearchHelpCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports